  export default {
      name: "CategoryTree",
      props: ["dataTree"]
  }



// WEBPACK FOOTER //
// ./src/views/components/CategoryTree/CategoryTree.component.js